import React from 'react'

import { Sidebar } from 'modules/workspace/components/Sidebar'

import { useShareWorkspaceSidebar } from '../../hooks/useShareWorkspaceSidebar'

interface ShareWorkspaceSidebarProps {
  workspaceIdentifier: string
}

const ShareWorkspaceSidebar: React.FC<ShareWorkspaceSidebarProps> = props => {
  const { workspaceIdentifier } = props

  const { shouldRenderWorkspaceSidebar, workspace } = useShareWorkspaceSidebar(
    workspaceIdentifier
  )

  if (shouldRenderWorkspaceSidebar) {
    return <Sidebar workspace={workspace!} />
  }

  return null
}

export default ShareWorkspaceSidebar
